<template>
  <div>
    <div v-if="value" class="refresh swapping-squares-spinner">
      <div class="refresh-box">
        <img class="image" src="../../assets/da.gif"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Loading",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.refresh {
  background-color: rgba(255, 255, 255, 1);
  position: fixed;
  z-index: 999999999999;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.refresh-box {
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
}
.image {
  width: 130px;
  height: 130px;
}
.text {
  font-size: 36rpx;
  font-weight: bold;
  text-align: center;
  margin-top: 20rpx;
}
@keyframes loading {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/loading/loading.vue